<template>
  <header>
    <v-container v-if="isMobile()" fluid>
      <v-layout wrap>
        <v-flex xs2>
          <div v-if="getShowRouterOptionsModal" class="close-button">
            <img
              src="../assets/Close.svg"
              alt="Cerrar"
              width="30px"
              height="30px"
              @click="showRouterOptionsModal(false)"
            />
          </div>
          <div v-else class="router-button">
            <a class="skip-link" @click="showRouterOptionsModal(true)">
              <span class="bar"></span>
              <span class="bar"></span>
              <span class="bar"></span>
            </a>
          </div>
        </v-flex>
        <v-flex xs4 class="logo">
          <img
            @click="showModal = true"
            src="../assets/ArtPlus&TanuwaImage.jpeg"
            alt="Image"
            height="50px"
            width="100px"
          />
        </v-flex>
        <v-flex xs6>
          <div
            v-show="getAuth"
            class="shopping-cart"
            @click="showShoppingCartModal(), showRouterOptionsModal(false)"
          >
            <div class="js-cart-widget-amount cart-summary-items">
              {{ getQuantityProds }}
            </div>
            <img
              src="../assets/CarritoDeCompras.svg"
              alt=""
              width="30px"
              height="30px"
              class="shopping-cart-img"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-else fluid>
      <v-layout wrap>
        <v-flex xs1>
          <img
            @click="showModal = true"
            src="../assets/ArtPlus&TanuwaImage.jpeg"
            alt="Image"
            height="100"
            width="170"
          />
        </v-flex>
        <v-flex xs10 class="pages-content">
          <router-link class="page" to="/">HOME</router-link>
          <router-link class="page" to="/products">PRODUCTOS</router-link>
          <router-link v-show="getAuth" class="page" to="/news"
            >NOVEDADES</router-link
          >
          <router-link v-show="getAuth" class="page" to="/tracking"
            >SEGUIMIENTO</router-link
          >
          <router-link class="page" to="/contact">CONTACTO</router-link>
        </v-flex>
        <v-flex xs1>
          <div
            v-show="getAuth"
            class="shopping-cart"
            @click="showShoppingCartModal()"
          >
            <div class="js-cart-widget-amount cart-summary-items">
              {{ getQuantityProds }}
            </div>
            <img
              src="../assets/CarritoDeCompras.svg"
              alt=""
              width="30px"
              height="30px"
              class="shopping-cart-img"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <ModalLogin v-if="showModal" @close="closeModal" />
    <ShoppingCartModal v-if="getShowShoppingCartModal" />
    <RouterOptionsModal v-if="getShowRouterOptionsModal" />
  </header>
</template>


<script>
import ModalLogin from "../components/ModalLogin";
import ShoppingCartModal from "../components/ShoppingCartModal";
import RouterOptionsModal from "../components/RouterOptionsModal";
import mobile_detection from "../mixins/mobile_detection";
import user_detection from "../mixins/user_detection";
import firebase from "firebase/firebase";
import "firebase/auth";

var auth = firebase.auth();

export default {
  mixins: [mobile_detection, user_detection],
  name: "Header",
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {},
  computed: {
    getShowShoppingCartModal() {
      return this.$store.getters.getShowShoppingCartModal;
    },
    getShowRouterOptionsModal() {
      return this.$store.getters.getShowRouterOptionsModal;
    },
    getQuantityProds() {
      let quantity = 0;

      this.$store.getters.getSelectedProducts.forEach((prod) => {
        prod.options.forEach((o) => {
          quantity += o.quantity;
        });
      });

      return quantity;
    },
  },
  methods: {
    showShoppingCartModal() {
      this.$store.commit("SET_SHOW_SHOPPING_CART_MODAL", true);
    },
    showRouterOptionsModal(bool) {
      this.$store.commit("SET_SHOW_ROUTER_OPTIONS_MODAL", bool);
    },
    closeModal() {
      this.showModal = false;
    },
  },
  components: {
    ModalLogin,
    ShoppingCartModal,
    RouterOptionsModal,
  },
};
</script>

<style>
.row {
  margin-left: 0;
  margin-right: 0;
}
header {
  color: #2c3e50;
  border-bottom-style: groove;
  position: sticky;
  display: block;
  background-color: white;
  width: 100%;
  top: 0;
  z-index: 999 !important;
  border-bottom: 1px solid #000;
  opacity: 0.97;
}
.logo {
  text-align: left;
}
.pages {
  text-align: center;
  margin-top: 30px;
}
.page {
  padding: 18px;
  margin-left: 20px;
  font-size: 20px;
  color: grey;
}
.shopping-cart {
  vertical-align: bottom;
  text-align: right;
  margin-right: 20px;
  margin-top: 35px;
}
.button {
  background-color: grey;
  border: black;
  color: white;
  padding: 15px;
  border-radius: 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 20px;
}
.user {
  text-align: center;
  display: inline-block;
  margin-top: 11px;
}

.pages-content {
  align-self: center;
  text-align: center;
}
.shopping-cart-img {
  cursor: pointer;
}

.cart-summary-items {
  background: #3498db;
  color: #ffffff;
  font-weight: bold;
}
.font-small,
.cart-summary,
.cart-summary-items,
.nav-head-top,
.pill-link,
.breadcrumb {
  font-size: 12px;
}
.cart-summary-items {
  position: absolute;
  right: 5px;
  padding: 0px 5px;
  line-height: 16px;
  border-radius: 50%;
  text-align: center;
  margin-right: 25px;
  margin-top: -15px;
}

@media only screen and (max-width: 767px) {
  .skip-link .bar {
    width: 23px;
    height: 3px;
    background: #808080;
    display: block;
    transform-origin: 0% 0%;
    margin-bottom: 4px;
  }

  .shopping-cart {
    margin-top: 16px;
  }
  .router-button {
    margin-top: 16px;
  }
  .close-button {
    margin-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue